import React, { memo, useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { ReactComponent as Download } from '../../../assets/img/icons/common/Download.svg';
import { LargeIconButton } from '../../../components/Buttons';
import ExportService from '../../../services/ExportService';
import ExportButtonOptions from './ExportButtonOptions';

const ExportButton = ({ distReqParams }) => {
  const [showBtnOptions, setShowBtnOptions] = useState(false);
  const [isExportRunning, setIsExportRunning] = useState(ExportService.isExportRunning);
  const startDate = useSelector(state => state.chickenDashboard?.startDate);
  const endDate = useSelector(state => state.chickenDashboard?.endDate);
  
  const onSubmit = exportOptions => {
    setIsExportRunning(true);
    
    const params = {
      ...distReqParams,
      dataSources: exportOptions.join(','),
    };
    
    ExportService.startExport(params);
    closeOptions();
  };
  
  const closeOptions = () => {
    setShowBtnOptions(false);
  };
  
  useEffect(() => {
    ExportService.onFinish = () => setIsExportRunning(false);
    
    return () => {
      ExportService.onFinish = null;
    };
  }, []);
  
  return (
    <>
      <LargeIconButton
        Icon={Download}
        isLoading={isExportRunning}
        disabled={startDate === 'select' || endDate === 'select'}
        onClick={() => setShowBtnOptions(true)}
      />
      
      {showBtnOptions ? (
        <ExportButtonOptions
          onSubmit={onSubmit}
          onCancel={closeOptions}
        />
      ) : null}
    </>
  );
};

export default memo(ExportButton);
